import BaseService from "@root/core/class/BaseService";

class wareHouseService extends BaseService {
  public getTotalCard = () => {
    return this.get("/totalInfo");
  };
  public getListOrderToday = () => {
    return this.get("/totalInfoToday");
  };
  public getListSeller = () => {
    return this.get("/sellers?page=1&limit=7");
  };

  public getNotifications = async (data: { page: number; limit: number }) => {
    const { page, limit } = data;
    return await this.get(`/notifications?page=${page}&limit=${limit}`);
  };

  public readNotification = async (id: number) => {
    return await this.post(`/notifications/${id}/mark-read`);
  };

  public isUnreadNotification = async () => {
    return await this.get(`/notifications/count-unread`);
  };

  public getNotiEventSource = () => {
    return this.initEventSource('/api/v1/warehouse/notifications/listen');
  };

  public deleteNotification = async (id: number) => {
    return await this.delete(`/notifications/${id}`)
  };
}
export default new wareHouseService("/api/v1/warehouse", true);
